import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Tabla from "../framework2/ej2/UI/Tabla"
import {CELLTIPO_CADENA, CELLTIPO_FECHA} from "../framework2/ej2/UI/TiposCeldas";



// --- Estilos ---
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const Modal = styled.div`
  background: white;
  padding: 20px;
  border-radius: 12px;
  width: 700px;
  max-width: 90%;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  text-align: center;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
`;

const Button = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;

  &.primary {
    background: #007bff;
    color: white;
  }

  &.secondary {
    background: #ccc;
  }
`;




// --- Componente de clase ---
class MarcajesDia extends Component {
    constructor(props) {
        super(props);
        this.state = {
            datos: props.marcajes,
        };

        this.columnas= [
            {campo:"fecha", titulo: "Fecha", tipo: CELLTIPO_CADENA, ancho:100},
            {campo:"personal", titulo: "Terminal", tipo: CELLTIPO_CADENA, ancho:200},
            {campo:"sede", titulo: "Sede", tipo: CELLTIPO_CADENA, ancho:140},
            //{campo:"tipoMarcaje", titulo: "Tipo", tipo: CELLTIPO_CADENA, ancho:100, obligatorio: true},
        ];

        console.log("MARCAJESDIA CONSTRUCTOR");
        console.log("props.marcajes: ", props.marcajes);

    }

    componentDidUpdate(prevProps) {
        // Si cambia visible a true, se resetean los valores iniciales
        if (this.props.visible && !prevProps.visible) {
            this.setState({
                datos: this.props.datos || {},
            });
        }
    }

    handleAccept = () => {
        this.props.onAccept && this.props.onAccept();
    };

    render() {
        const {datos} = this.state;
        console.log ("RENDER");
        console.log ("datos: ", datos);

        if (!this.props.visible) {
            return null; // no se renderiza si no está visible
        }

        return (
            <Overlay>
                <Modal>
                    <h3>Marcajes de hoy</h3>
                    {datos &&
                        <>
                            <Tabla
                                columnas={this.columnas}
                                datos={datos}
                                alto={400}
                            />
                        </>
                    }

                    <Buttons>
                        <Button className="primary" onClick={this.handleAccept}>
                            Aceptar
                        </Button>
                    </Buttons>
                </Modal>
            </Overlay>
        );
    }
}

// --- PropTypes ---
MarcajesDia.propTypes = {
    visible: PropTypes.bool.isRequired,
    marcajes: PropTypes.object.isRequired,
    onAccept: PropTypes.func.isRequired,
};

export default MarcajesDia;
